import { createFileRoute } from '@tanstack/react-router'

import { AchNachaRatesScreen } from './-components/ach-nacha-rates-screen.tsx'

export const Route = createFileRoute('/ach/nacha-rates')({
  component: AchNachaRatesScreen
})
